export const categories = [
  { id: 'mingxing-bagua', name: '明星八卦', slug: 'mingxing-bagua', description: '娱乐圈明星最新八卦爆料', icon: 'ri-star-line' },
  { id: 'wanghong-baoliao', name: '网红爆料', slug: 'wanghong-baoliao', description: '网红主播达人私密爆料', icon: 'ri-live-line' },
  { id: 'dujia-neirong', name: '独家内容', slug: 'dujia-neirong', description: '黑料网独家深度爆料', icon: 'ri-file-lock-line' },
  { id: 'zongyi-neimu', name: '综艺内幕', slug: 'zongyi-neimu', description: '综艺节目幕后真实故事', icon: 'ri-tv-line' },
  { id: 'yinyue-quan', name: '音乐圈', slug: 'yinyue-quan', description: '音乐圈歌手乐手最新动态', icon: 'ri-music-line' },
];

export const hotTags = [
  '恋情曝光', '出轨实锤', '整容风波', '税务问题', '综艺撕逼',
  '人设崩塌', '学历造假', '合约纠纷', '家庭背景', '私生子',
];